import SettingsView from 'components/organisms/settings/SettingsView'
import React from 'react'

const Settings = () => {
    return (
        <SettingsView />
    )
}

export default Settings